// In-memory mapping of assistant message id -> user (parent) message id, namespaced by session

const map = new Map<string, string>();

const keyOf = (sessionId: string | null, assistantId: string | null | undefined): string | null => {
    if (!sessionId || !assistantId) return null;
    return `${sessionId}:${assistantId}`;
};

export const setMessageUserMapping = (sessionId: string | null, assistantMessageId: string | null, userMessageId: string | null) => {
    const key = keyOf(sessionId, assistantMessageId || undefined);
    if (!key || !userMessageId) return;
    map.set(key, String(userMessageId));
};

export const getUserIdForAssistant = (sessionId: string | null, assistantMessageId: string | null | undefined): string | undefined => {
    const key = keyOf(sessionId, assistantMessageId);
    if (!key) return undefined;
    const val = map.get(key);
    return val ? String(val) : undefined;
};


